<template>
    <LocationsList/>
</template>

<script>
import LocationsList from '../../components/locations/LocationsList';

export default {
  components: {
    LocationsList,
  },
};
</script>
